export default __webpack_public_path__ + "static/media/materialize-1.dba83dbd.jpg";